package com.hyperether.goodjob.scenes.landing

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.hyperether.goodjob.containerSize
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.success
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.pricing.PricingViewModel
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.theme.LandingPageBg
import com.hyperether.resources.currentLanguage
import org.jetbrains.compose.resources.stringResource

@Composable
fun LandingPage(
    isMobileView: Boolean,
    pricingViewModel: PricingViewModel,
    continueToRegister: () -> Unit,
    onOpenPdf: (String) -> Unit
) {
    val plans = if (getPlatformChecker().isMobile()) {
        pricingViewModel.plans.collectAsState(initial = emptyList()).value
    } else {
        pricingViewModel.plansRemote.collectAsState(initial = emptyList()).value.sortedBy { it.price }
    }

    LaunchedEffect(plans) {
        if (plans.isNotEmpty()) {
            val popularPlan = plans.find { it.isPopular == true }
            pricingViewModel.selectedPlan.value = popularPlan?.getName(currentLanguage.value.code)
            pricingViewModel.selectedPlanId.value = popularPlan?._id
            pricingViewModel.showLoader.value = false
        }
    }

    LaunchedEffect(isMobileView) {
        pricingViewModel.getAllPlans()
    }

    if (pricingViewModel.showLoader.value) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(LandingPageBg),
            contentAlignment = Alignment.Center
        ) {
            FullScreenProgressBar()
        }
    } else {
        if (!isMobileView) {
            SelectionContainer {
                LandingPageWebView(
                    containerSize = containerSize,
                    plans = plans,
                    enteredEmail = pricingViewModel.enteredEmail,
                    continueToRegister = continueToRegister,
                    selectedOption = pricingViewModel.selectedOption,
                    subscribeUser = {
                        pricingViewModel.subscribeUser()
                    },
                    onOpenPdf = onOpenPdf
                )
            }
        } else {
            LandingPageMobileView(
                selectedOption = pricingViewModel.selectedOption,
                containerSize = containerSize,
                plans = plans,
                enteredEmail = pricingViewModel.enteredEmail,
                savePlanLocally = {  },
                continueToRegister = continueToRegister,
                subscribeUser = {
                    pricingViewModel.subscribeUser()
                },
                onOpenPdf = onOpenPdf
            )
        }
    }
    if (pricingViewModel.showPopUpSuccess.value) {
        PopUpDialog(
            onDismiss = {
                pricingViewModel.showPopUpSuccess.value = false
            },
            title = stringResource(Res.string.success).uppercase(),
            message = pricingViewModel.messageText.value,
            positiveBtnText = stringResource(Res.string.ok),
            onPositiveBtnClicked = {
                pricingViewModel.showPopUpSuccess.value = false
                pricingViewModel.enteredEmail.value = ""
            }
        )
    }
    if (pricingViewModel.showPopUpError.value) {
        ErrorDialog(
            onDismiss = { pricingViewModel.showPopUpError.value = false },
            title = stringResource(Res.string.error).uppercase(),
            message = pricingViewModel.messageText.value
        )
    }
}